import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  FBPageEyebrow,
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from '../../../components/FbUI/Page/styles'
import { RemindersTableProvider } from 'components/Reminders/RemindersTable'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
import { WorkspaceOutlineIcon } from 'components/Layout/LeftNav/nav-icons'

export function RemindersPage() {
  return (
    <FBPage
      innerPageClassName="!bg-[#fefefe]"
      containerClassName="!bg-[#fefefe] !shadow-none"
    >
      <FBPageHeader className="!mb-6">
        <FBPageTitleRow>
          <div className="flex flex-col items-start">
            <FBPageEyebrow>
              <WorkspaceOutlineIcon size={14} />
              Workspace
            </FBPageEyebrow>
            <FBPageTitle className="!text-fg">Reminders</FBPageTitle>
          </div>
        </FBPageTitleRow>
      </FBPageHeader>

      <TableLinkStyleProvider variant="plain">
        <FBPageTableContainer
          className="flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]"
          style={{
            height: 'calc(var(--base-page-table-height) - 10px)',
          }}
        >
          <RemindersTableProvider tableKey={'reminders-table'} />
        </FBPageTableContainer>
      </TableLinkStyleProvider>
    </FBPage>
  )
}
